import { palette } from '$tablet-app/src/app/theme';
import React, { FC } from 'react';
import { StyleSheet, ViewProps } from 'react-native';
import Row from '../Row';
import Text from '../Text';

interface BadgeProps extends ViewProps {
  text: string;
  color?: string;
  backgroundColor?: string;
}

const Badge: FC<BadgeProps> = ({
  text,
  color = palette.white,
  backgroundColor,
  style,
}) => {
  const textColor = color ? { color } : undefined;
  const bgColor = backgroundColor ? { backgroundColor } : undefined;

  return (
    <Row
      style={StyleSheet.flatten([styles.badge, bgColor, style])}
      justifyContent="center"
      alignItems="center"
    >
      <Text bold style={textColor}>
        {text}
      </Text>
    </Row>
  );
};

// Styles
const styles = StyleSheet.create({
  badge: {
    height: 35,
    width: 35,
    borderRadius: 20,
    backgroundColor: palette.black,
  },
});

export default Badge;
